import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function fetchFontList(params) {
  return request({
    url: `${v2Host}/common/font/list`,
    method: 'get',
    params,
  })
}

export function checkForbiddenFont(params) {
  return request({
    url: `${v2Host}/common/font/check`,
    method: 'get',
    params,
  })
}

export function manageFontList(params) {
  return request({
    url: `${v2Host}/font/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function deleteFont(data) {
  return request({
    url: `${v2Host}/font/delete?id=${data.id}`,
    method: 'post',
    data,
  })
}

export function addFont(data) {
  return request({
    url: `${v2Host}/font/add`,
    method: 'post',
    data: cookRequestParams(data),
  })
}

export function downloadFont(params) {
  return request({
    url: `${v2Host}/font/download?id=${params.id}`,
    method: 'get',
    data: cookRequestParams(params),
  })
}

export function updateFont(data) {
  return request({
    url: `${v2Host}/font/update?id=${data.id}`,
    method: 'post',
    data: cookRequestParams(data),
  })
}

/**
 * 字体裁切
 * @param data {{text: string, font: string, font_url: string}}
 * @returns {AxiosPromise}
 */
export function cropFont(data) {
  return request({
    url: `${v2Host}/common/font/crop`,
    method: 'post',
    data,
  })
}
